/* Aurora: every product card button reads "Add to Cart".
   Eyesight products: the card button still opens the product page (so powers get selected).
   Normal products: direct add-to-cart as before. */
(function(){
'use strict';
function run(){
  document.querySelectorAll('a.quick-add__submit').forEach(function(a){
    if(/buy now/i.test(a.textContent))a.textContent='Add to Cart';
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
setInterval(run,1000);
document.addEventListener('shopify:section:load',run);
})();
